/**
 * Settings API Endpoints
 * Framework-agnostic endpoint definitions for settings modules
 */

/**
 * FAQ API Endpoints
 */
export const FAQ_ENDPOINTS = {
  LIST: "programs/get-faq",
  CREATE: "programs/create-faq",
  UPDATE: "programs/update-faq",
} as const;

/**
 * Privacy Policy API Endpoints
 */
export const PRIVACY_POLICY_ENDPOINTS = {
  GET: "programs/get-privacy-policy",
  UPDATE: "programs/update-privacy-policy",
} as const;

/**
 * Terms & Conditions API Endpoints
 */
export const TERMS_CONDITION_ENDPOINTS = {
  GET: "programs/get-terms-condition",
  UPDATE: "programs/update-terms-condition",
} as const;

/**
 * Combined Settings Endpoints
 */
export const SETTINGS_ENDPOINTS = {
  faq: FAQ_ENDPOINTS,
  privacyPolicy: PRIVACY_POLICY_ENDPOINTS,
  termsCondition: TERMS_CONDITION_ENDPOINTS,
} as const;
